<template>
    <component
        :is="icon"
        v-if="icon"
        v-once
        class="icon"
        :class="{'no-fill': noFill}"
    />
</template>

<script>
// please keep these in alphabetical order
import Amex from '@whisper-svg/icon-amex.svg';
import ArrowHorizontal from '@whisper-svg/icon-arrow-horizontal.svg';
import ArrowHorizontalLong from '@whisper-svg/icon-arrow-horizontal-long.svg';
import ArrowVertical from '@whisper-svg/icon-arrow-vertical.svg';
import ArrowVerticalLong from '@whisper-svg/icon-arrow-vertical-long.svg';
import Beam from '@whisper-svg/icon-beam.svg';
import CalendarError from '@whisper-svg/icon-calendar-error.svg';
import CalendarHeart from '@whisper-svg/icon-calendar-heart.svg';
import CalendarPhone from '@whisper-svg/icon-calendar-phone.svg';
import Cart from '@whisper-svg/icon-cart.svg';
import Checkmark from '@whisper-svg/icon-checkmark.svg';
import Chevron from '@whisper-svg/icon-chevron.svg';
import Clipboard from '@whisper-svg/icon-clipboard.svg';
import ClippingPath from '@whisper-svg/icon-clipping-path.svg';
import Close from '@whisper-svg/icon-close.svg';
import Copy from '@whisper-svg/icon-copy.svg';
import CreditCards from '@whisper-svg/icon-credit-cards.svg';
import Deals from '@whisper-svg/icon-deals.svg';
import DinersClub from '@whisper-svg/icon-DinersClub.svg';
import Discover from '@whisper-svg/icon-discover.svg';
import Diversity from '@whisper-svg/icon-diversity.svg';
import Download from '@whisper-svg/icon-download.svg';
import Ecommerce from '@whisper-svg/icon-ecommerce.svg';
import EcommerceService from '@whisper-svg/icon-ecommerce-service.svg';
import EditingProfiles from '@whisper-svg/icon-editing-profiles.svg';
import Email from '@whisper-svg/icon-email.svg';
import Events from '@whisper-svg/icon-events.svg';
import EventsService from '@whisper-svg/icon-events-service.svg';
import Exclamation from '@whisper-svg/icon-exclamation.svg';
import Expand from '@whisper-svg/icon-expand.svg';
import FacebookCircle from '@whisper-svg/icon-facebook-circle.svg';
import FacebookLike from '@whisper-svg/icon-facebook-like.svg';
import Fashion from '@whisper-svg/icon-fashion.svg';
import FashionService from '@whisper-svg/icon-fashion-service.svg';
import Feedback from '@whisper-svg/icon-feedback.svg';
import FlagEn from '@whisper-svg/icon-flag-en.svg';
import FlagFr from '@whisper-svg/icon-flag-fr.svg';
import Flexibility from '@whisper-svg/icon-flexibility.svg';
import Food from '@whisper-svg/icon-food.svg';
import FoodService from '@whisper-svg/icon-food-service.svg';
import Headshots from '@whisper-svg/icon-headshots.svg';
import HeadshotsService from '@whisper-svg/icon-headshots-service.svg';
import Heart from '@whisper-svg/icon-heart.svg';
import Info from '@whisper-svg/icon-info.svg';
import Instagram from '@whisper-svg/icon-instagram.svg';
import JCB from '@whisper-svg/icon-JCB.svg';
import LightBulb from '@whisper-svg/icon-light-bulb.svg';
import Lightroom from '@whisper-svg/icon-lightroom.svg';
import Linkedin from '@whisper-svg/icon-linkedin-square.svg';
import ListCollapse from '@whisper-svg/icon-list-collapse.svg';
import ListExpand from '@whisper-svg/icon-list-expand.svg';
import Mastercard from '@whisper-svg/icon-mastercard.svg';
import MenuBars from '@whisper-svg/icon-menu.svg';
import OfficeChair from '@whisper-svg/icon-office-chair.svg';
import PayPal from '@whisper-svg/icon-paypal.svg';
import PetLove from '@whisper-svg/icon-pet-love.svg';
import PhotographyService from '@whisper-svg/icon-photography-service.svg';
import Phone from '@whisper-svg/icon-phone.svg';
import PhotoshopDark from '@whisper-svg/icon-photoshop-dark.svg';
import PhotoshopLight from '@whisper-svg/icon-photoshop-light.svg';
import PlaceOrder from '@whisper-svg/icon-place-order.svg';
import Play from '@whisper-svg/icon-play.svg';
import PostProductionService from '@whisper-svg/icon-post-production-service.svg';
import Presets from '@whisper-svg/icon-presets.svg';
import Pringles from '@whisper-svg/icon-pringles.svg';
import Quality from '@whisper-svg/icon-quality.svg';
import Question from '@whisper-svg/icon-question.svg';
import QuestionSolid from '@whisper-svg/icon-question-solid.svg';
import Quotes from '@whisper-svg/icon-quotes.svg';
import RealEstate from '@whisper-svg/icon-real-estate.svg';
import RealEstateService from '@whisper-svg/icon-real-estate-service.svg';
import Reload from '@whisper-svg/icon-reload.svg';
import Respect from '@whisper-svg/icon-respect.svg';
import Search from '@whisper-svg/icon-search.svg';
import SkyReplacement from '@whisper-svg/icon-sky-replacement.svg';
import Spinner from '@whisper-svg/icon-spinner.svg';
import Studio from '@whisper-svg/icon-studio.svg';
import Support from '@whisper-svg/icon-support.svg';
import Twitter from '@whisper-svg/icon-twitter.svg';
import Upload from '@whisper-svg/icon-upload.svg';
import VideoPause from '@whisper-svg/icon-video-pause.svg';
import VideoPlay from '@whisper-svg/icon-video-play.svg';
import Videos from '@whisper-svg/icon-video.svg';
import VideoService from '@whisper-svg/icon-video-services.svg';
import VideoServiceInverted from '@whisper-svg/icon-video-services-inverted.svg';
import ViewOrders from '@whisper-svg/icon-view-orders.svg';
import Visa from '@whisper-svg/icon-visa.svg';
import Yoga from '@whisper-svg/icon-yoga.svg';

export default {
  // please keep these in alphabetical order
  components: {
    Amex,
    ArrowHorizontal,
    ArrowHorizontalLong,
    ArrowVertical,
    ArrowVerticalLong,
    Beam,
    CalendarError,
    CalendarHeart,
    CalendarPhone,
    Cart,
    Checkmark,
    Chevron,
    Clipboard,
    ClippingPath,
    Close,
    Copy,
    CreditCards,
    Deals,
    DinersClub,
    Discover,
    Diversity,
    Download,
    Ecommerce,
    EcommerceService,
    EditingProfiles,
    Email,
    Events,
    EventsService,
    Exclamation,
    Expand,
    FacebookCircle,
    FacebookLike,
    Fashion,
    FashionService,
    Feedback,
    FlagEn,
    FlagFr,
    Flexibility,
    Food,
    FoodService,
    Headshots,
    HeadshotsService,
    Heart,
    Info,
    Instagram,
    JCB,
    LightBulb,
    Lightroom,
    Linkedin,
    ListCollapse,
    ListExpand,
    Mastercard,
    MenuBars,
    OfficeChair,
    PayPal,
    PetLove,
    PhotographyService,
    Phone,
    PhotoshopDark,
    PhotoshopLight,
    PlaceOrder,
    Play,
    PostProductionService,
    Presets,
    Pringles,
    Quality,
    Question,
    QuestionSolid,
    Quotes,
    RealEstate,
    RealEstateService,
    Reload,
    Respect,
    Search,
    SkyReplacement,
    Spinner,
    Studio,
    Support,
    Twitter,
    Upload,
    VideoPause,
    VideoPlay,
    VideoService,
    VideoServiceInverted,
    Videos,
    ViewOrders,
    Visa,
    Yoga,
  },
  props: ['icon', 'noFill'],
};
</script>

<style>
    .icon {
        max-width: 128px;
        max-height: 128px;
        overflow: visible;
    }

    .icon:not(.no-fill) {
        fill: currentColor;
        @apply fill-current;
    }
</style>
